import { NgModule } from '@angular/core';
import { Route, RouterModule, ROUTES, Routes } from '@angular/router';

import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';

import { ChooseAccountWrapperComponent } from '../containers/choose-account-wrapper/choose-account-wrapper.component';
import { PaymentConfirmationWrapperComponent } from '../containers/payment-confirmation-wrapper/payment-confirmation-wrapper.component';
import { PaymentReviewWrapperComponent } from '../containers/payment-review-wrapper/payment-review-wrapper.component';
import { ReviewPaymentWrapperComponent } from '../containers/review-payment-wrapper/review-payment-wrapper.component';
import { SimplifiedPaymentChooseAccountWrapperComponent } from '../containers/simplified-payment-choose-account-wrapper/simplified-payment-choose-account-wrapper.component';
import { SimplifiedPaymentConfirmationWrapperComponent } from '../containers/simplified-payment-confirmation-wrapper/simplified-payment-confirmation-wrapper.component';
import { OneTimePayBreadcrumbResolver } from '../util/one-time-pay-breadcrumb.resolver';
import { OneTimePayGuard } from './one-time-pay.guard';

const routes: Routes = [
  {
    path: 'review-payment',
    component: ReviewPaymentWrapperComponent,
    data: { breadcrumb: 'Review Payment' },
    canActivate: [OneTimePayGuard],
    canDeactivate: [OneTimePayGuard]
  },
  {
    path: 'confirmation',
    component: PaymentConfirmationWrapperComponent,
    data: { breadcrumb: 'Confirmation' },
    canActivate: [OneTimePayGuard],
    canDeactivate: [OneTimePayGuard]
  },
  {
    path: 'payment-review',
    resolve: { resolvedData: OneTimePayBreadcrumbResolver },
    component: PaymentReviewWrapperComponent,
    data: { breadcrumb: 'useResolvedData', resolveKey: 'payment-review' },
    canActivate: [OneTimePayGuard],
    canDeactivate: [OneTimePayGuard]
  },
  {
    path: 'payment-confirmation',
    resolve: { resolvedData: OneTimePayBreadcrumbResolver },
    component: SimplifiedPaymentConfirmationWrapperComponent,
    data: {
      breadcrumb: 'useResolvedData',
      resolveKey: 'payment-confirmation'
    },
    canActivate: [OneTimePayGuard],
    canDeactivate: [OneTimePayGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [
    OneTimePayGuard,
    {
      provide: ROUTES,
      useFactory: (featureFlagService: FeatureFlagService) => {
        const featureFlagSimplfiedPaymentRoute: Route = {
          path: 'choose-accounts',
          component: featureFlagService.isEnabled('simplified_payment')
            ? SimplifiedPaymentChooseAccountWrapperComponent
            : ChooseAccountWrapperComponent,
          data: {
            breadcrumb: featureFlagService.isEnabled('simplified_payment')
              ? 'Make a Payment'
              : 'Choose Accounts'
          },
          canActivate: [OneTimePayGuard],
          canDeactivate: [OneTimePayGuard]
        };
        return [...routes, featureFlagSimplfiedPaymentRoute];
      },
      deps: [FeatureFlagService],
      multi: true
    }
  ],
  exports: [RouterModule]
})
export class OneTimePayRoutingModule {}
